// extracted by mini-css-extract-plugin
export var card = "_sm-0";
export var details = "_sm-1";